/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: DashboardTable
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 03Aug2022 craig File created.
 \******************************************************************************/
import React, {ReactNode, useState} from "react";
import "./DashboardTable.css";
import {
    ISubmission,
    ITeam,
    ITeamSubmissionLinkage,
    ITeamUserLinkage
} from "../../models/application/IApplication";
import {Col, Container, Row} from "react-bootstrap";
import {IUser, RoleEnum} from "../../models/user/IUser";
import {InfoDialog} from "../dialogs/InfoDialog";

//export const DashboardTable = (linkages: ITeamSubmissionLinkage[] | undefined) => {
export const DashboardTable = (user: IUser, team?: ITeam) => {

    const [showUserInfo, setShowUserInfo] = useState<boolean>(false);
    const [userInfo, setUserInfo] = useState<ReactNode>("null");
    const linkages = team?.TeamSubmissionLinkage;
    if (linkages === undefined || linkages.length === 0) {
        return (
            <Container>
                <Row>
                    <Col>No submissions found</Col>
                </Row>
            </Container>
        )
    }

    const toggleModal = () => {
        setShowUserInfo(!showUserInfo);
    };

    const handleShowUserInfo = (user?: IUser) => {
        setShowUserInfo(true);
        setUserInfo(BuildUserInfo(user));
    }

    const BuildDashboardKey = () => {
        return (
            <Container className={"legend"}>
                <Row className={"row-legend"}>
                    <Col className={"row-legend red-status"}/>
                    <Col className={"row-legend-text"}>Review not yet started</Col>
                </Row>
                <Row className={"row-legend"}>
                    <Col className={"row-legend yellow-status"}/>
                    <Col className={"row-legend-text"}>Review in progress</Col>
                </Row>
                <Row className={"row-legend"}>
                    <Col className={"row-legend green-status"}/>
                    <Col className={"row-legend-text"}>Review complete</Col>
                </Row>
            </Container>

        )
    }


    const getUsersDashboard = (user: IUser, team?: ITeam) => {
        const linkages = team?.TeamSubmissionLinkage;
        const users = team?.TeamUserLinkage;
        if (users === undefined || users.length === 0) {
            return (
                <Container>
                    <Row>
                        <Col>No users found</Col>
                    </Row>
                </Container>
            )
        }
        return (
            <Container>
                {users?.map((reviewer: ITeamUserLinkage) => (
                    ReviewerRow(user, team, reviewer, linkages)
                ))}
                {BuildDashboardKey()}
            </Container>
        )
    }

    /**
     * build the user info dialog
     *
     * @param user - user info to show
     * @constructor
     */
    const BuildUserInfo = (user?: IUser) => {
        return (
            <Container>
                <Row>
                    <Col>Name</Col>
                    <Col>{user?.FirstName} {user?.LastName}</Col>
                </Row>
                <Row>
                    <Col>
                        Email:
                    </Col>
                    <Col>
                        {user?.EmailAddress}
                    </Col>
                </Row>
                <Row>
                    <Col>Title:</Col>
                    <Col>{user?.Title}</Col>
                </Row>
                <Row>
                    <Col>Organization:</Col>
                    <Col>{user?.Organization}</Col>
                </Row>
            </Container>

        )
    }
    const ReviewerRow = (user: IUser, team?: ITeam, reviewer?: ITeamUserLinkage, linkages?: ITeamSubmissionLinkage[]) => {
        const userID = reviewer?.GSUser?.UserID === undefined ? "-1" : reviewer?.GSUser?.UserID.toString();
        return (
            <Row className={"status"} key={"user-" + userID}>
                <Col className={"status"}>
                    <a className={"team-member"} onClick={() => handleShowUserInfo(reviewer?.GSUser)}>{reviewer?.GSUser?.FirstName + " " + reviewer?.GSUser?.LastName}</a>
                </Col>
                {linkages?.map((submissionLinkage: ITeamSubmissionLinkage) => (
                    ReviewerRowText(user, team, reviewer, submissionLinkage)
                ))}
            </Row>
        );
    }

    const ReviewerRowText = (user: IUser, team?: ITeam, reviewer?: ITeamUserLinkage, linkage?: ITeamSubmissionLinkage) => {
        const appDataURL = "/submission/" + reviewer?.UserID + "/" + team?.TeamID + "/" + linkage?.SubmissionID + "/P1";
        //const appDataURL = "/submissionp1/" + reviewer?.UserID + "/" + team?.TeamID + "/" + linkage?.SubmissionID;
        let statusClass = "cell-status red-status"
        //let statusClass:string = "";
        let key: string = "";
        let submitted: boolean = false;
        if (linkage?.SubmissionID !== undefined) {
            if (reviewer?.GSUser?.TeamUserSubmissionLinkage !== null && reviewer?.GSUser?.TeamUserSubmissionLinkage !== undefined) {
                if (reviewer?.GSUser?.TeamUserSubmissionLinkage[linkage.SubmissionID] !== undefined) {
                    if (reviewer?.GSUser?.TeamUserSubmissionLinkage[linkage.SubmissionID].Submitted) {
                        statusClass = "cell-status green-status"
                        submitted = true;
                    }
                    key = linkage?.SubmissionID.toString() + "-" + reviewer?.GSUser?.UserID.toString();
                }
            }
            if (!submitted) {
                //check if the user has done any reviews for this submisison
                if (reviewer?.ReviewStatus !== null && reviewer?.ReviewStatus[linkage?.SubmissionID] !== null && reviewer?.ReviewStatus[linkage?.SubmissionID] !== undefined) {
                    const statusNum = reviewer?.ReviewStatus[linkage?.SubmissionID];
                    if (statusNum !== undefined) {
                        if (statusNum > 0 /*&& statusNum <= 6*/) {
                            //status = "yellow.png";
                            statusClass = "cell-status yellow-status"
                        } /*else {
                            //status = "green.png";
                            statusClass = "cell-status green-status"
                        }*/
                    }
                    key = linkage?.SubmissionID.toString() + "-" + reviewer?.GSUser?.UserID.toString();
                }
            }
        }

        if ((reviewer?.GSUser?.UserID === user.UserID) || (user.RoleID === RoleEnum.Admin || user.RoleID === RoleEnum.GS_Admin)) {
            return <Col id={key} className={statusClass}><a className={"status"}
                                                             href={appDataURL}>{"View Submission"}</a></Col>
        } else {
            return <Col id={key} className={statusClass}></Col>
        }
    }

    const getHeader = () => {
        return <Col className={"header-container"}>
            <Container>
                <Row key={"blank"}>
                    &nbsp;
                </Row>
                <Row key={"num-emp-header"}>
                    <Col className={"dashboard-header-label"}>Num Employees:</Col>
                </Row>
                <Row key={"num-locations-header"}>
                    <Col className={"dashboard-header-label"}>Num Locations:</Col>
                </Row>
            </Container>
        </Col>
    }
    const getSubmissionLink = (submission: ISubmission) => {
        if (submission !== undefined && submission.Organization !== undefined) {
            if (submission.OrgDataMap["Account_Website"] !== undefined &&
                submission.OrgDataMap["Account_Website"]?.ResponseList[0] !== undefined &&
                submission.OrgDataMap["Account_Website"]?.ResponseList[0].Response !== null) {
                let url:string = submission.OrgDataMap["Account_Website"]?.ResponseList[0].Response;
                if (!url.startsWith("https://")) {
                    url = "https://" + url;
                }
                return <a href={url} rel={"noreferrer"} target={"_blank"}>{submission.Organization}</a>
            }
            else {
                return <span>{submission.Organization}</span>
            }
        }
        else {
            return "N/A";
        }
    }

    const getHeaderValue = (submission: ISubmission, label: string) => {
        if (submission !== undefined && submission.OrgDataMap[label] !== undefined &&
            submission.OrgDataMap[label]?.ResponseList[0] !== undefined &&
            submission.OrgDataMap[label]?.ResponseList[0].Response !== null) {
            return submission.OrgDataMap[label]?.ResponseList[0].Response;
        } else {
            return "N/A";
        }
    }


    return (
        <Container>
            <InfoDialog title={"User Information"} body={userInfo} show={showUserInfo} showHide={toggleModal}/>
            <Row className={"dashboard-header-row"}>
                <Col className={"header-container dashboard-header"}>
                    {getHeader()}
                </Col>
                {linkages?.map((submissionLinkage: ITeamSubmissionLinkage) => (
                    <Col key={"dashboard-header" + submissionLinkage.Submission.SubmissionID} className={"header-container dashboard-header"}>
                        <Container>
                            <Row key={"sub-name"}>
                                {getSubmissionLink(submissionLinkage.Submission)}
                            </Row>
                            <Row key={"sub-emp_count"}>
                                <Col>{getHeaderValue(submissionLinkage.Submission, "Approx_US_Employee_Count")}</Col>
                            </Row>
                            <Row key={"sub-location-count"}>
                                <Col>{getHeaderValue(submissionLinkage.Submission, "Approx_US_Locations")}</Col>
                            </Row>
                        </Container>
                    </Col>
                ))}
            </Row>
            <Row>
                {getUsersDashboard(user, team)}
            </Row>
        </Container>
    )
}

